export default __webpack_public_path__ + "static/article-managing-the-reno-budget-what-to-consider-fc7047b49ef383911b76543a4866b807.jpg";